<ng-template #loadingGeneral>

  <mat-spinner class="center"></mat-spinner>
  <h4 class="center">Loading...</h4>

</ng-template>

<mat-card appearance="outlined" fxLayout="column" *ngIf="!loading else loadingGeneral">
  <mat-card-header>
    <mat-card-title>{{invoice?.id}}</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <mat-list>
      <mat-list-item>
        <h3>
          <strong>Address:</strong>
          {{invoice?.addressLine1}}
        </h3>
      </mat-list-item>
      <mat-list-item>
        <h3>
          <strong>E-mail:</strong>
          {{invoice?.email}}
        </h3>
      </mat-list-item>

      <mat-list-item>
        <h3>
          <strong>Contact Phone: </strong>
          {{invoice?.phone}}
        </h3>
      </mat-list-item>
      <mat-list-item>
        <h3>
          <strong>identifier:</strong>
          {{invoice?.identifier}}
        </h3>
      </mat-list-item>
      <mat-list-item>
        <h3>
          <strong>description:</strong>
          {{invoice?.description}}
        </h3>
      </mat-list-item>
      <mat-list-item>
        <h3>
          <strong>City:</strong>
          {{invoice?.city}}
        </h3>
      </mat-list-item>
      <mat-list-item>
        <h3>
          <strong>ContractId:</strong>
          {{invoice?.contractId}}
        </h3>
      </mat-list-item>
    </mat-list>
  </mat-card-content>
</mat-card>